import { Menu }                from "@mantine/core";
import { useEffect, useState } from "react";

import Toast                  from "_common/toast";
import Chip                   from "_components/atoms/chips";
import Icon                   from "_components/atoms/icon";
import Typography             from "_components/atoms/typography";
import CoinsCount             from "_components/molecules/coinsCount";
import EditSettingsMenuFooter from "_components/molecules/editSettingsMenuFooter";
import FeatureInput           from "_components/molecules/fanRankInput";

import useStyles from "./styles";

const component = props => {
	const {
		handleClose,
		featureAmount,
		saveAndEnableFeature,
		type,
		title,
		minLimit,
		maxLimit,
		userProfile,
		defaultMsg
	} = props;

	const { classes } = useStyles ();

	const [ amount, setAmount ]     = useState ( featureAmount || "" );
	const [ errorMsg, setErrorMsg ] = useState ( "" );

	useEffect ( () => {
		if ( amount )
			setErrorMsg ( getErrMsg () );
		else setErrorMsg ( null );
	}, [ amount ] );

	const getErrMsg = () => {
		if ( !parseInt ( amount ) )
			return "Cannot set the zero value";

		if ( type === "donation" )
			return null;

		if ( !userProfile )
			return "You need to be logged in";

		if ( amount && parseInt ( amount ) < minLimit )
			return `Enter Amount Between ${ minLimit } Coins - ${ ( maxLimit ).toLocaleString () } Coins`;

		if ( userProfile.totalPoints < parseInt ( amount ) )
			return "You don't have enough coins";

		if ( maxLimit && amount > maxLimit )
			return `You cannot enter more than ${ maxLimit } Coins`;

		return null;

	};

	const getTag = type => {
		if ( type === "donation" )
			return (
				<Icon sameInBothTheme
					className = { classes.svgIcon }
					name      = "diamond"
				/>
			);

		if ( type === "fanRank" )
			return (
				<Icon sameInBothTheme
					className = { classes.svgIcon }
					name      = "rooterCoinIcon"
				/>
			);
	};

	const btnClickHandler = ( e, amount ) => {
		setAmount ( amount );
		// if ( type === "donation" )
		// handleAmountChange ( e, amount );
		// else {
		// handleAmountChange ( e, userProfile.totalPoints, amount );
		// }
	};

	const inputChangeHandler = e => {
		setAmount ( e.target.value );
	};

	const suggestedAmountList = [ 1000, 2000, 5000 ];

	const onClickSaveBtn = () => {
		if ( errorMsg || !amount ) return;
		if ( maxLimit && amount > maxLimit ) return;
		if ( amount < 0 ) {
			Toast.error ( "Cannot set negative value." );

			return;
		}

		saveAndEnableFeature ( parseInt ( amount ) );
	};

	return (
		<Menu.Dropdown>
			<div className = { classes.headerContainer }>
				<Typography
					className = { classes.tagHeader }
					// color = "secondary"
					title     = { title }
				/>

				{
					type === "fanRank" ? <CoinsCount coinsCount = { userProfile.totalPoints } /> : null
				}
			</div>

			<div className = { classes.modalBody }>
				<FeatureInput
					defaultMsg                = { defaultMsg }
					errorMsg                  = { errorMsg }
					fanRankAmount             = { amount }
					handleFanRankAmountChange = { inputChangeHandler }
					type                      = { type }
					userProfile               = { userProfile }
				/>

				<div className = { classes.chipGroup }>
					<Chip.Group>
						{suggestedAmountList.map ( amt => (
							<Chip
								key       = { amt }
								active    = { amount === amt }
								className = { classes.btn }
								onClick   = { e => {
									btnClickHandler ( e, amt );
								} }
							>
								{getTag ( type )}

								{amt}
							</Chip>
						)
						)}
					</Chip.Group>

				</div>
			</div>

			<EditSettingsMenuFooter
				onCancel      = { handleClose }
				onSubmit      = { onClickSaveBtn }
				submitBtnText = "Save"
			/>

			{/* <ModalFooter
				onCancel = { handleClose }
				onSave = { onClickSaveBtn }
			/> */}

		</Menu.Dropdown>
	);
};

export default component;
